import Singleton from "../Components/Singleton";
class Connection {

    getHeader = () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${Singleton.getInstance()}`)
        myHeaders.append("Accept", `application/json`)
        myHeaders.append("Content-Type", `application/json`)

        return myHeaders
    }

    async post(url, param) {
        const response = await fetch(`${process.env.REACT_APP_REDA_URL}${url}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: this.getHeader(),
            body: JSON.stringify(param)
        });
        return response;
    }

    async get(url) {
        const response = await fetch(`${process.env.REACT_APP_REDA_URL}${url}`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: this.getHeader()
        });

        return response;
    }
}

export default new Connection()